module.exports = __webpack_public_path__ + "assets/img/5cee040819d397d32a825862e3da2e57.png";